import { StyleSheet } from 'react-native'
import { Palette } from '@ppwr/poker'

const CREAM = Palette['Brand/Cream']
const BLACK = Palette['Global/Black']

export const teacherControlStyles = StyleSheet.create({
  // Common button styles
  button: {
    padding: 10,
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 0,
    backgroundColor: CREAM
  },
  activeButton: {
    backgroundColor: BLACK
  },
  buttonText: {
    color: BLACK,
    fontSize: 13,
    fontWeight: '600'
  },
  activeButtonText: {
    color: CREAM
  },

  // Legacy aliases kept for sub-components
  pauseButton: {
    backgroundColor: CREAM
  },
  resumeButton: {
    backgroundColor: BLACK
  },

  // Popover styles
  popoverContent: {
    minWidth: 220,
    maxWidth: 260,
    maxHeight: 300,
    padding: 12
  },
  popoverHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255, 255, 255, 0.1)'
  },
  popoverTitle: {
    color: 'white',
    fontSize: 14,
    fontWeight: '600',
    flex: 1
  },
  backArrow: {
    color: 'white',
    fontSize: 18,
    fontWeight: '600'
  },
  popoverDivider: {
    height: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    marginVertical: 8
  },

  // Recipient/player list styles
  recipientList: {
    gap: 6,
    maxHeight: 180
  },
  recipientItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 10,
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    borderRadius: 6
  },
  recipientItemAll: {
    backgroundColor: 'rgba(124, 77, 255, 0.3)',
    borderWidth: 1,
    borderColor: 'rgba(124, 77, 255, 0.5)'
  },
  recipientItemActive: {
    backgroundColor: 'rgba(76, 175, 80, 0.3)',
    borderWidth: 1,
    borderColor: 'rgba(76, 175, 80, 0.5)'
  },
  recipientIcon: {
    fontSize: 14,
    color: 'white'
  },
  recipientNameRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    minWidth: 0
  },
  recipientName: {
    color: 'white',
    fontSize: 13,
    fontWeight: '500',
    flex: 1,
    minWidth: 0
  },
  recipientChips: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: 12,
    fontWeight: '400'
  },
  checkmark: {
    color: '#4CAF50',
    fontSize: 14,
    fontWeight: '600'
  },

  // Give Chips specific styles
  giveChipsButton: {
    backgroundColor: CREAM
  },
  chipButtonRow: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'center'
  },
  chipButton: {
    backgroundColor: CREAM,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 6,
    minWidth: 50,
    alignItems: 'center'
  },
  chipButtonText: {
    color: BLACK,
    fontSize: 14,
    fontWeight: '600'
  },

  // Add Bots specific styles
  addBotsButton: {
    backgroundColor: CREAM
  },
  sheetContainer: {
    paddingHorizontal: 20,
    paddingTop: 12,
    paddingBottom: 20,
    gap: 16
  },
  sheetHeader: {
    gap: 4
  },
  sheetTitle: {
    color: BLACK,
    fontSize: 20,
    fontWeight: '700'
  },
  sheetSubtitle: {
    color: 'rgba(0, 0, 0, 0.7)',
    fontSize: 13,
    fontWeight: '500'
  },
  sheetHint: {
    color: 'rgba(0, 0, 0, 0.55)',
    fontSize: 12
  },
  skillRows: {
    gap: 10
  },
  skillRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    paddingVertical: 10,
    paddingHorizontal: 12,
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    borderRadius: 10
  },
  skillInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flex: 1
  },
  skillSwatch: {
    width: 18,
    height: 18,
    borderRadius: 9,
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.08)'
  },
  skillLabel: {
    color: BLACK,
    fontSize: 15,
    fontWeight: '600'
  },
  skillStepper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  },
  skillStepperButton: {
    width: 34,
    height: 34,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: BLACK
  },
  skillStepperButtonDisabled: {
    backgroundColor: 'rgba(0, 0, 0, 0.12)'
  },
  skillStepperButtonPressed: {
    opacity: 0.85
  },
  skillStepperButtonText: {
    color: CREAM,
    fontSize: 20,
    fontWeight: '700'
  },
  skillStepperButtonTextDisabled: {
    color: 'rgba(0, 0, 0, 0.35)'
  },
  skillStepperCount: {
    minWidth: 24,
    alignItems: 'center'
  },
  skillStepperCountText: {
    color: BLACK,
    fontSize: 16,
    fontWeight: '700'
  },
  stepperActions: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'flex-end'
  },
  smallButton: {
    paddingVertical: 6,
    paddingHorizontal: 16,
    borderRadius: 4,
    minWidth: 60,
    alignItems: 'center'
  },
  smallButtonText: {
    color: 'white',
    fontSize: 12,
    fontWeight: '600'
  },
  cancelButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)'
  },
  sheetFooter: {
    gap: 12
  },
  sheetFooterText: {
    color: BLACK,
    fontSize: 14,
    fontWeight: '600'
  },
  sheetActions: {
    flexDirection: 'row',
    gap: 10
  },
  sheetSecondaryButton: {
    flex: 1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.08)'
  },
  sheetSecondaryButtonDisabled: {
    opacity: 0.45
  },
  sheetSecondaryButtonText: {
    color: BLACK,
    fontSize: 14,
    fontWeight: '600'
  },
  sheetPrimaryButton: {
    flex: 1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: BLACK
  },
  sheetPrimaryButtonDisabled: {
    backgroundColor: 'rgba(0, 0, 0, 0.18)'
  },
  sheetPrimaryButtonText: {
    color: CREAM,
    fontSize: 14,
    fontWeight: '700'
  },
  sheetPrimaryButtonTextDisabled: {
    color: 'rgba(0, 0, 0, 0.35)'
  },

  // Remove Player specific styles (same as other teacher control buttons)
  removePlayerButton: {
    backgroundColor: CREAM
  },
  removeConfirmButton: {
    backgroundColor: BLACK
  },
  removeConfirmButtonText: {
    color: CREAM
  },
  confirmText: {
    color: 'white',
    fontSize: 13,
    marginBottom: 4,
    lineHeight: 20
  },
  confirmNameHighlight: {
    fontWeight: '700',
    color: 'white'
  },
  confirmHint: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: 11,
    marginBottom: 4
  }
})
